import { render } from "./ShareMobile.vue?vue&type=template&id=6622130b&scoped=true&ts=true"
import script from "./ShareMobile.vue?vue&type=script&lang=ts"
export * from "./ShareMobile.vue?vue&type=script&lang=ts"

import "./ShareMobile.vue?vue&type=style&index=0&id=6622130b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6622130b"]])

export default __exports__